import { render } from "./AddRuleSet.vue?vue&type=template&id=e90e65d6&ts=true"
import script from "./AddRuleSet.vue?vue&type=script&lang=ts"
export * from "./AddRuleSet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__